module.exports = __webpack_public_path__ + "static/media/rtm-logo.fcff832f.svg";